import React from "react";
import Container from "react-bootstrap/Container";
import {
  Title,
  SpinnerContainer,
  ButtonContainer,
  ViewsContainer,
} from "../../ui/BaseComponents";
import { Spinner, Stack } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import CreateServiceType from "../create/CreateServiceType";
import DeleteServiceType from "../delete/DeleteServiceTypes";
import UpdateServiceType from "../update/UpdateServiceTypes";
import { ContentHeader } from "../../ui/BaseComponents";

export default function ViewServiceTypes({ data, isLoading, fetchData }) {
  return (
    <Container fluid>
      <Title>{"Service Type Details"}</Title>
      {isLoading ? (
        <SpinnerContainer>
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
          <Spinner animation='grow' variant='danger' />
        </SpinnerContainer>
      ) : (
        <Stack>
          <ContentHeader>{"Service Types"}</ContentHeader>
          <ViewsContainer style={{ padding: "1em", margin: "0 2%" }}>
            <ButtonContainer
              style={{
                marginBottom: ".5%",
                marginTop: ".5%",
                paddingLeft: ".5%",
              }}
            >
              <CreateServiceType fetchData={fetchData} />
            </ButtonContainer>
            <Table hover borderless>
              <thead>
                <tr
                  style={{
                    borderBottom: "2px solid rgba(0, 0, 0, 0.29)",
                    color: "#292929",
                  }}
                >
                  <th></th>
                  <th></th>
                  <th>Service Type</th>
                  <th>Description</th>
                  <th>Created Date</th>
                  <th>Last Updated</th>
                </tr>
              </thead>
              <tbody>
                {data.map((item: any, i) => (
                  <tr
                    key={i}
                    style={
                      i % 2 === 0
                        ? {
                            borderBottom: ".02em solid rgba(0, 0, 0, 0.19)",
                            backgroundColor: "#D8ECFD",
                            color: "#292929",
                          }
                        : {
                            borderBottom: ".02em solid rgba(0, 0, 0, 0.19)",
                            backgroundColor: "#ECF3FE",
                            color: "#292929",
                          }
                    }
                  >
                    <td>
                      {
                        <UpdateServiceType
                          fetchData={fetchData}
                          id={item.id}
                          item={item}
                        />
                      }
                    </td>
                    <td>
                      {<DeleteServiceType fetchData={fetchData} id={item.id} />}
                    </td>
                    <td>{item.name}</td>
                    <td>{item.description}</td>
                    <td>{item.create_date}</td>
                    <td>{item.last_updated_date}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </ViewsContainer>
        </Stack>
      )}
    </Container>
  );
}
